import "./ArticleSlide.scss"
import "swiper/css"
import 'swiper/css/autoplay';
import 'swiper/css/navigation';

import { useEffect, useState } from "react"
import { data, useParams } from "react-router-dom"
import ArticleCard from "../ArticleCard/ArticleCard";
import { getDataFromCMS } from "../../service/service";

import { A11y, Autoplay, Navigation } from "swiper/modules"
import { Swiper, SwiperSlide } from 'swiper/react'

const ArticleSlide = () => {
    const [articles, setArticles] = useState([])
    const { id } = useParams()

    useEffect(() => {
         getDataFromCMS("blog").then((data) => {
            setArticles(data)
         }).catch(() => {
            setArticles(false)
         })
    }, [id])

    return (
        <section className="slides">
        <h3>Other blogs</h3>
            {articles.length > 1 && (
                <div className="slide-article__wrapper">
                    <Swiper
                        modules={[A11y, Autoplay, Navigation]}
                        spaceBetween={20} 
                        navigation={true} 
                        loop={true}
                        centeredSlides={true} 
                        autoplay={{
                            delay: 3500,
                            disableOnInteraction: false,
                        }}
                        breakpoints={{
                            1100: { slidesPerView: 3 }, 
                            520: { slidesPerView: 2, centeredSlides: false },  
                            0: { slidesPerView: 1 } 
                        }}
                    >
                        {articles.map(article => (
                                <SwiperSlide className="slide" key={article.id}>
                                    <ArticleCard article={article} />
                                </SwiperSlide>
                            ))}
                    </Swiper>
                </div>
            )}
        </ section>
    )
}

export default ArticleSlide

